const documentTypeLabels: Record<string, string> = {
  KBIS: 'Kbis',
  COMPANY_AUTHORIZATION: 'Autorisation d\'entreprise',
  CNAPS: 'CNAPS',
  ARTICLES_OF_ASSOCIATION: 'Statuts',
  REGISTRATION_PROOF: 'Justificatif d\'inscription',
  IDENTITY_PROOF: 'Pièce d\'identité',
  PRO_CARD: 'Carte professionnelle',
  ID_CARD: 'Carte d\'identité',
  PROOF_OF_ADDRESS: 'Justificatif de domicile',
  RESIDENT_ID_CARD: 'Carte de résident',
  AUTHORIZATION_ATTESTATION: 'Attestation d\'autorisation',
};

export function getDocumentTypeLabel(type: string): string {
  return documentTypeLabels[type] ?? type;
}
